var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linear/code"
  }, /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.55664 9C8.53664 9.49 9.37664 10.23 9.98664 11.15C10.3366 11.67 10.3366 12.34 9.98664 12.86C9.37664 13.77 8.53664 14.51 7.55664 15",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6667 15H17.6667",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66675 22H15.6667C20.6667 22 22.6667 20 22.6667 15V9C22.6667 4 20.6667 2 15.6667 2H9.66675C4.66675 2 2.66675 4 2.66675 9V15C2.66675 20 4.66675 22 9.66675 22Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2C);
export default __webpack_public_path__ + "static/media/b2c.8cd212821e356e86652d22550c017ef1.svg";
export { ForwardRef as ReactComponent };